// Handle the checkbox functionality
document.addEventListener('DOMContentLoaded', function() {
	const filterForms = document.querySelectorAll('.gnist-filter__checkbox');
	
	filterForms.forEach(form => {
		const checkboxes = form.querySelectorAll('.gnist-filter__checkbox-input');
		const allCheckbox = form.querySelector('.gnist-filter__checkbox-all');
		
		// Handle "All" checkbox
		if (allCheckbox) {
			allCheckbox.addEventListener('change', function() {
				if (this.checked) {
					// Uncheck all other checkboxes
					checkboxes.forEach(checkbox => {
						if (checkbox !== this) {
							checkbox.checked = false;
						}
					});
					// Submit the form
					const form = this.closest('form');
					if (form) {
						form.submit();
					}
				}
			});
		}
	});
});
